import localStorageService from "app/services/localStorageService";
import { RestMethod } from "app/_helpers/ApiConfig/RestMethod";
import { CallApi } from "app/_helpers/CallApi/CallApi";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import { addMinutes } from "app/_helpers/helper";
import {
  employeeEmploymentStatusObj,
  fliterBtnType,
} from "app/_pages/UserManagement/Employee/Constant";
import moment from "moment";
import { getAllSites, getAllSitesData } from "../ehs/ehsSiteServices";
import { useDispatch, useSelector } from "react-redux";
import configureStore from "../../redux/Store";
import { clearEmployeesStore } from "app/_pages/UserManagement/UserRegistration/helper";
import { USER_DATA_CONSTANT } from "app/_constants/Redux/userData.constant";
let { Store } = configureStore();

export async function getEmployee(filter, filterType = false) {
  let storeKey;
  let storeType;

  switch (filterType) {
    case fliterBtnType.inActiveUnAssigned.type:
      storeKey = "employeeInActiveUnassigned";
      storeType = USER_DATA_CONSTANT.EMPLOYEE_IN_ACTIVE_UNASSIGNED;
      break;
    case fliterBtnType.inActiveAssigned.type:
      storeKey = "employeeInActiveAssigned";
      storeType = USER_DATA_CONSTANT.EMPLOYEE_IN_ACTIVE_ASSIGNED;
      break;
    default:
      storeKey = "employee";
      storeType = USER_DATA_CONSTANT.SET_EMPLOYEE_DATA;
      break;
  }
  const employeeData = Store.getState()?.userManagement?.[storeKey];
  if (
    (Array.isArray(employeeData) && employeeData?.length === 0) ||
    (filter &&
      JSON.stringify(filter) !==
        JSON.stringify({
          apiFlag: true,
        }))
  ) {
    let result = {};
    const currentDate = new Date();
    const currentTime = moment(currentDate, "HH:mm").format("HH:mm");
    const saveData = localStorageService.getItem("employeeListData");
    const addTime = saveData?.time ? addMinutes(saveData?.time, 5) : "";
    const url =
      "/user-management/employees" + ((filterType && `?type=${filterType}`) || "");

    const siteList = await getAllSites();
    const siteListData = await getAllSitesData();
    if (saveData?.data && addTime >= currentTime && !filter?.apiFlag) {
      result = saveData?.data;
    } else {
      result = await CallApi(url, "GET");
      const obj = { time: currentTime, data: result };
    }

    const { status, message, data, other } = result;
    let response = {
      status: status,
      message: message,
      data: {
        ...data,
        employees: data?.employees?.map((d, index) => {
          const siteObj =
            (siteList?.data || [])?.find((obj) => obj?.id === d?.currentWorkLocation) ||
            (siteListData?.data || [])?.find((obj) => obj?.id === d?.currentWorkLocation);
          const formAObj =
            (other?.employee_form_a || [])?.find((obj) => obj?.employeeId === d?.id) ||
            "";
          return {
            ...d,
            sid: index + 1,
            name: `${d.firstName} ${d.middleName} ${d.lastName}`,
            dmyDob: DDMMYYYYFormat(d.dob),
            userStatus: d.userId ? "YES" : "NO",
            viewEmploymentStatus: employeeEmploymentStatusObj[d.employmentStatus],
            staffType: "employee",
            ehsSite: siteObj,
            siteType: siteObj?.siteType || "",
            employeeFormA: formAObj,
          };
        }),
      },
    };
    Store.dispatch({
      type: storeType,
      data: response,
    });
    return {
      status,
      message,
      data: {
        ...data,
        employees: data?.employees?.map((d, index) => {
          const siteObj =
            (siteList?.data || [])?.find((obj) => obj?.id === d?.currentWorkLocation) ||
            (siteListData?.data || [])?.find((obj) => obj?.id === d?.currentWorkLocation);
          const formAObj =
            (other?.employee_form_a || [])?.find((obj) => obj?.employeeId === d?.id) ||
            "";
          return {
            ...d,
            sid: index + 1,
            name: `${d.firstName} ${d.middleName} ${d.lastName}`,
            dmyDob: DDMMYYYYFormat(d.dob),
            userStatus: d.userId ? "YES" : "NO",
            viewEmploymentStatus: employeeEmploymentStatusObj[d.employmentStatus],
            staffType: "employee",
            ehsSite: siteObj,
            siteType: siteObj?.siteType || "",
            employeeFormA: formAObj,
          };
        }),
      },
    };
  } else {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from store",
          data: { employees: employeeData },
        });
      }, 0);
    });
  }
  // return {
  //   status,
  //   message,
  //   data: {
  //     ...data,
  //     employees: data?.employees?.map((d, index) => {
  //       const siteObj = (siteList?.data || [])?.find(
  //         (obj) => obj?.id === d?.currentWorkLocation
  //       );
  //       const formAObj =
  //         (other?.employee_form_a || [])?.find((obj) => obj?.employeeId === d?.id) || "";
  //       return {
  //         ...d,
  //         sid: index + 1,
  //         name: `${d.firstName} ${d.middleName} ${d.lastName}`,
  //         dmyDob: DDMMYYYYFormat(d.dob),
  //         userStatus: d.userId ? "YES" : "NO",
  //         viewEmploymentStatus: employeeEmploymentStatusObj[d.employmentStatus],
  //         staffType: "employee",
  //         ehsSite: siteObj,
  //         siteType: siteObj?.siteType || "",
  //         employeeFormA: formAObj,
  //       };
  //     }),
  //   },
  // };
}

export async function getEmployeeByID(id) {
  try {
    const response = await RestMethod.GET("/user-management/employees/" + id);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function createEmployee(data) {
  try {
    const response = await RestMethod.POST("/user-management/employees", data);
    if (response?.data?.status) {
      clearEmployeesStore();
    }
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function updateEmployee(id, data) {
  try {
    const response = await RestMethod.PUT("/user-management/employees/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function updateBasicDetailsOfEmployee(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/user-management/employees/update-employee-basic-data/" + id,
      data
    );
    if (response?.data?.status) {
      clearEmployeesStore();
    }
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getAllEmployeeFormAHistoryByID(id) {
  const url = "/user-management/employees/form-a/history-all/" + id;

  const response = await RestMethod.GET(url);

  return response;
}
export async function getEmployeeFormAHistoryByID(id) {
  const url = "/user-management/employees/form-a/history/" + id;

  const response = await RestMethod.GET(url);

  return response;
}
export async function updateEmployeeEmploymentStatusOfEmployee(id, data, query) {
  // try {
  //   const response = await RestMethod.PUT(
  //     "/user-management/employees/update-employee-employment-status/" + id,
  //     data
  //   );
  //   return response.data;
  // } catch (error) {
  //   console.log("error detected while fetching data from api");
  //   return null;
  // }
  let url = "/user-management/employees/update-employee-employment-status/" + id;
  if (query) url = url + "?" + query;
  let response = await CallApi(url, "PUT", data);
  if (response?.data?.status) {
    clearEmployeesStore();
  }
  return response;
}

export async function updateEmployeeCurrentLocationOfEmployee(id, data, query) {
  let url = "/user-management/employees/update-employee-current-location/";
  if (id) url = url + id;
  if (query) url = url + "?" + query;

  let response = await CallApi(url, "PUT", data);
  if (response?.data?.status) {
    clearEmployeesStore();
  }
  return response;
}

export async function updateEmployeeDesignationOfEmployee(id, data) {
  let url = "/user-management/employees/update-employee-designation/" + id;
  return await CallApi(url, "PUT", data);
}

export async function updateMedicalOfEmployee(id, data) {
  let url = "/user-management/employees/update-employee-medical-exam/" + id;
  return await CallApi(url, "PUT", data);
}

export async function updateEmployeeFormA(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/user-management/employees/form-a/" + id,
      data
    );
    if (response.data.status) {
      Store.dispatch({
        type: USER_DATA_CONSTANT.FORM_A,
        data: [],
      });
    }
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function deleteEmployee(id, data) {
  try {
    const response = await RestMethod.DELETE("/user-management/employees/" + id, data);
    if (response?.data?.status) {
      clearEmployeesStore();
    }
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export const uploadEmployeesExcel = async (data) => {
  let url = "/user-management/employees/upload-employees-excel";
  return await CallApi(url, "POST", data);
};

export const addEmployeesExcel = async (data) => {
  let url = "/user-management/employees/add-employees-excel";
  let response = await CallApi(url, "POST", data);
  if (response?.data?.status) {
    clearEmployeesStore();
  }
  return response;
};

export const updateSiteHistory = async (data, query) => {
  let url = "/user-management/update-site-history";
  if (query) url += "?" + query;
  let response = await CallApi(url, "POST", data);
  if (response?.data?.status) {
    clearEmployeesStore();
  }
  return response;
};

export const updateTrainingHistory = async (data) => {
  let url = "/user-management/employees/update-training-history";
  return await CallApi(url, "POST", data);
};

export const updateMedicalHistory = async (data) => {
  let url = "/user-management/employees/update-medical-history";
  let response = await CallApi(url, "POST", data);
  if (response?.data?.status) {
    clearEmployeesStore();
  }
  return response;
};

export const employeeToUser = async (data) => {
  let url = "/user-management/employees/employee-user-conversion";
  let response = await CallApi(url, "POST", data);
  if (response?.status) {
    clearEmployeesStore();
  }
  return response;
};

export const downloadEmployeesExcel = async () => {
  let url = "/user-management/employees/download-employees-excel";
  return await CallApi(url, "GET");
};

export async function checkCurrentMedicalInprogress(id, query) {
  let url = "/user-management/employees/check-current-medical-inprogress/";
  if (id) url = url + id;
  if (query) url = url + "?" + query;

  let response = await CallApi(url, "GET");
  return response;
}

export async function getEmployeeForOtherModuel() {
  const resultData = Store.getState()?.userManagement?.employeeForOthrModuel;
  if (Array.isArray(resultData) && resultData?.length) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from Store",
          data: resultData,
        });
      }, 0);
    });
  } else {
    let url = "/user-management/employees/for-other-moduel";
    let response = await CallApi(url, "GET");
    Store.dispatch({
      type: USER_DATA_CONSTANT.EMPLOYEE_FOR_OTHER_MODUEL,
      data: response?.data,
    });
    return response;
  }
}

export async function getAllOldEmployee() {
  const resultData = Store.getState()?.userManagement?.oldEmployee;
  if (Array.isArray(resultData) && resultData?.length) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from Store",
          data: resultData,
        });
      }, 0);
    });
  } else {
    let url = "/user-management/employees/all-old-employee";
    let response = await CallApi(url, "GET");
    Store.dispatch({
      type: USER_DATA_CONSTANT.OLD_EMPLOYEE,
      data: response?.data,
    });
    return response;
  }
}

// export async function getAssignedOrUnAssignedEmployee(type) {
//   // const resultData = Store.getState()?.userManagement?.oldEmployee;
//   const resultData = [];
//   if (Array.isArray(resultData) && resultData?.length) {
//     return new Promise((resolve) => {
//       setTimeout(() => {
//         resolve({
//           status: 1,
//           message: "Data from Store",
//           data: resultData,
//         });
//       }, 0);
//     });
//   } else {
//     let url = "/user-management/employees/all-assigned-or-unassigned-employee/"+ type;
//     let response = await CallApi(url, "GET");
//     // Store.dispatch({
//     //   type: USER_DATA_CONSTANT.OLD_EMPLOYEE,
//     //   data: response?.data,
//     // });
//     return response;
//   }
// }
